// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__6n0ne","sliderContainer":"Slider_sliderContainer__p8q8f","helper":"Slider_helper__G5e6U"};